import React from 'react'
import { Grid, TextField, Snackbar, IconButton } from '@mui/material'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
function MerInteger(props) {
    
    const [value,setValue] = useState(props.info.value);
    // const [open, setOpen] = useState(false);
    // const [message, setMessage] = useState('');

    // const handleClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //     return;
    //     }
    //     setOpen(false);
    // };

    // const action = (
    //     <React.Fragment>
    //     <IconButton
    //         size="small"
    //         aria-label="close"
    //         color="inherit"
    //         onClick={handleClose}
    //     >
    //         <CloseIcon fontSize="small" />
    //     </IconButton>
    //     </React.Fragment>
    // );

    return (
    // <div>
        <TextField 
        type='number'
        InputLabelProps={{
            style: { color: 'black' },
        }}
        sx={{marginBottom:2,marginTop:2, maxWidth:'75%', 
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'black',
                },
           },
           '& .MuiFormLabel-asterisk': {
            color: 'red', fontSize: '30px'
            }
        }}
        onWheel={(e) => e.target.blur()}
        required={props.info.mandatory}
        autoComplete='off'
        value={value}
        disabled={!props.abled}
        onChange={(e) => {
            //console.log(e.target.value)
            if (props.info.question_type === 'integer' && (e.target.value - Math.floor(e.target.value)) !== 0){
                props.setOpen(true)
                props.setMessage('You cannot enter decimal point (.)')
                return
            }
            if (e.target.value < 0){
                props.setOpen(true)
                props.setMessage('You cannot enter negative value')
                return
            }
            setValue(e.target.value);
            props.handleChange(props.info.id,e.target.value,props.info?._id);
        }}
        label={props.info.question_text}
        variant="outlined"
        InputProps={{
            inputProps: { min: 0 }
          }}
        />
        // <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} action={action} message={message}/>
    // </div>
    )
}

export default MerInteger
